import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {itemsOfContentSelector} from "../../ducks/content";
import Sidebar from "../Sidebar";

import styles from "./department-sidebar.module.scss";

function DepartmentSidebar(props) {
  const {items} = props;
  return (
    <div className={styles.root}>
      <Sidebar items={items} />
    </div>
  );
}

DepartmentSidebar.propTypes = {
  items: PropTypes.array
};

export default connect((state) => ({
  items: itemsOfContentSelector(state)
}))(DepartmentSidebar);
